export default __webpack_public_path__ + "images/bf3d7f11cd0766539a052f6f0f7d012a-douleutaras-trained.svg";